import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import BillingLogsDashboard from "./components/BillingLogsDashboard";
import Breadcrumps from "../../components/modules/Breadcrumps";
import Loader from "../../components/elements/Loader";
import NoBillingLogs from "./components/NoBillingLogs";
import PageLayout from "../../layouts/PageLayout";
import api from "../../api";
import classes from "./BillingLogsPage.module.scss";
import { BillingLogType } from "../../types/advertiserTypes";

export const fetchBillingLogs = async (brandgenAdvertiserId: string) => {
  try {
    const { payload } = await api.getBillingLogForAdvertiser(brandgenAdvertiserId);
    return payload;
  } catch (error) {
    const err = error as any;
    throw new Error(err);
  }
};

const BillingLogsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [billingLogs, setBillingLogs] = useState<BillingLogType[]>([]);

  const history = useHistory();
  const params: { id: string } = useParams();

  const handleBack = () => {
    history.push(`/advertisers/${params.id}`);
  };

  useEffect(() => {
    const fetchAndSetBillingLogs = async () => {
      try {
        setIsLoading(true);
        const fetchedBillingLogs = await fetchBillingLogs(params.id);
        setBillingLogs(fetchedBillingLogs);
        setIsLoading(false);
      } catch (error) {
        const err = error as any;
        // eslint-disable-next-line no-console
        console.log("fetchAndSetBillingLogs error: ", err.message);
        setIsLoading(false);
      }
    };

    fetchAndSetBillingLogs();
  }, [params.id]);

  const breadcrumps = [
    { label: "Home", link: "/dashboard", active: false },
    { label: "Advertisers", link: "/advertisers", active: false },
    { label: "Advertiser Detail", link: `/advertisers/${params.id}`, active: false },
    { label: "Billing Logs", link: `/advertisers/${params.id}/billing-logs`, active: true },
  ];

  return (
    <PageLayout heading="Billing Logs">
      <Breadcrumps breadcrumps={breadcrumps} className={classes.breadcrumps} />

      {isLoading ? (
        <Loader />
      ) : !isLoading && billingLogs.length === 0 ? (
        <NoBillingLogs handleBack={handleBack} />
      ) : (
        <BillingLogsDashboard billingLogs={billingLogs} />
      )}
    </PageLayout>
  );
};

export default BillingLogsPage;
